export const updatePropertyRelationshipModalPageSource = 'update_property_relationship_modal';
